import React from "react";
import { Table } from "antd";
import { CustomCellRenderer } from "./CustomCellRenderer";
import formatWithUnits from "../utils/currencyFormat";

/**
 * CustomTable - Holdings table component
 * 
 * Displays fund holdings with available fields:
 * - Stock Name, Sector
 * - Value (in Mn)
 * - % of Total Holdings
 * - 1 Month Change (%)
 * 
 * Removed fields (no longer available from MoneyControl):
 * - Quantity
 * - 1 Month Qty Change
 * - 1 Year Highest %
 * - 1 Year Lowest %
 * - New Entry
 */
const CustomTable = ({ data }) => {
  // Column Definitions
  const columns = [
    {
      title: "Stock Name",
      dataIndex: "stockName",
      key: "stockName",
      width: 250,
    },
    {
      title: "Sector",
      dataIndex: "stockSector",
      key: "stockSector",
      width: 180,
    },
    {
      title: "Value (₹ Mn)",
      dataIndex: "valueInMn",
      key: "valueInMn",
      render: (value) => formatWithUnits(value, " ₹"),
      sorter: (a, b) => (a.valueInMn || 0) - (b.valueInMn || 0),
      width: 120,
    },
    {
      title: "Weightage (%)",
      dataIndex: "percentageOfTotalHoldings",
      key: "percentageOfTotalHoldings",
      render: (value) => value ? `${value.toFixed(2)}%` : '-',
      sorter: (a, b) =>
        (a.percentageOfTotalHoldings || 0) - (b.percentageOfTotalHoldings || 0),
      width: 120,
    },
    {
      title: "1M Change (%)",
      dataIndex: "oneMonthChangeInPtHoldings",
      key: "oneMonthChangeInPtHoldings",
      render: (value) => <CustomCellRenderer value={value} />,
      sorter: (a, b) => 
        (a.oneMonthChangeInPtHoldings || 0) - (b.oneMonthChangeInPtHoldings || 0),
      width: 120,
    },
  ];

  return (
    <Table
      columns={columns}
      dataSource={data}
      rowKey={(record, index) => record.id || `row-${index}`}
      pagination={{
        pageSize: 10,
        showSizeChanger: true,
        pageSizeOptions: ["10", "20", "50", "100"],
        defaultPageSize: 10,
      }}
      scroll={{ x: 800 }}
    />
  );
};

export default CustomTable;
